export default class ManagementCalculationRuleParameterHistory {
  name: string;

  value: string;

  previous: string;

  constructor(obj: any = {}) {
    this.name = obj.name || '';
    this.value = obj.value || '';
    this.previous = obj.previous || '';
  }

  public static of(obj: any = {}): ManagementCalculationRuleParameterHistory {
    return new ManagementCalculationRuleParameterHistory(obj);
  }

  public static ofList(obj: any[]): ManagementCalculationRuleParameterHistory[] {
    return obj.map(this.of);
  }
}
